import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] rounded-full">
              <i className="ri-home-heart-line text-2xl text-white"></i>
            </div>
            <div>
              <div className="text-xl font-bold text-[#2C2C2C]">ぽかぽか堂</div>
              <div className="text-sm text-[#757575]">よりみち相談室</div>
            </div>
          </a>

          <div className="flex items-center gap-6">
            <a 
              href="/" 
              className="text-base font-medium text-[#2C2C2C] hover:text-[#66BB6A] transition-colors cursor-pointer whitespace-nowrap"
            >
              個人向けサポート
            </a>
            <a 
              href="#contact" 
              className="bg-gradient-to-r from-[#66BB6A] to-[#4CAF50] text-white px-6 py-3 rounded-full text-base font-bold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
